import React from 'react'

export function NeonCity({ className = '' }) {
  return (
    <svg
      viewBox="0 0 1200 600"
      className={`w-full h-full ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
    >
      <defs>
        <linearGradient id="citySky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#0f0c29" />
          <stop offset="50%" stopColor="#302b63" />
          <stop offset="100%" stopColor="#240b36" />
        </linearGradient>
        <linearGradient id="metalGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#2c3e50" />
          <stop offset="100%" stopColor="#000000" />
        </linearGradient>
        <filter id="neonCyan" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="neonMagenta" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Background */}
      <rect width="1200" height="600" fill="url(#citySky)" />

      {/* Distant Skyline */}
      <g fill="#0a0a1a" opacity="0.8">
        <rect x="50" y="200" width="100" height="400" />
        <rect x="180" y="300" width="120" height="300" />
        <rect x="350" y="150" width="150" height="450" />
        <rect x="550" y="250" width="90" height="350" />
        <rect x="700" y="100" width="180" height="500" />
        <rect x="920" y="280" width="110" height="320" />
        <rect x="1080" y="180" width="100" height="420" />
      </g>

      {/* Window Lights */}
      <g fill="#00ffff" opacity="0.5">
        <rect x="70" y="220" width="10" height="10" />
        <rect x="90" y="220" width="10" height="10" />
        <rect x="70" y="250" width="10" height="10" />
        <rect x="380" y="180" width="15" height="15" />
        <rect x="420" y="180" width="15" height="15" />
        <rect x="380" y="220" width="15" height="15" />
        <rect x="750" y="150" width="20" height="5" />
        <rect x="750" y="180" width="20" height="5" />
        <rect x="750" y="210" width="20" height="5" />
      </g>

      {/* Main Platform */}
      <g transform="translate(200, 450)">
        <path d="M20 0 L780 0 L800 20 L750 150 L50 150 L0 20 Z" fill="url(#metalGrad)" />
        <path d="M20 0 L780 0" stroke="#00ffff" strokeWidth="6" filter="url(#neonCyan)" />
        <path d="M20 0 L0 20 L50 150" stroke="#ff00ff" strokeWidth="4" filter="url(#neonMagenta)" fill="none" />
        <path d="M780 0 L800 20 L750 150" stroke="#ff00ff" strokeWidth="4" filter="url(#neonMagenta)" fill="none" />
        <rect x="100" y="20" width="600" height="10" fill="#111" />
        <rect x="150" y="22" width="50" height="6" fill="#00ffff" filter="url(#neonCyan)" />
        <rect x="600" y="22" width="50" height="6" fill="#00ffff" filter="url(#neonCyan)" />
      </g>

      {/* Left Floating Platform */}
      <g transform="translate(150, 280)">
        <path d="M10 0 L240 0 L250 10 L220 40 L30 40 L0 10 Z" fill="url(#metalGrad)" />
        <path d="M10 0 L240 0" stroke="#ff00ff" strokeWidth="4" filter="url(#neonMagenta)" />
      </g>

      {/* Right Floating Platform */}
      <g transform="translate(800, 280)">
        <path d="M10 0 L240 0 L250 10 L220 40 L30 40 L0 10 Z" fill="url(#metalGrad)" />
        <path d="M10 0 L240 0" stroke="#ff00ff" strokeWidth="4" filter="url(#neonMagenta)" />
      </g>

      {/* Top Center Floating Platform */}
      <g transform="translate(475, 150)">
        <path d="M10 0 L240 0 L250 10 L220 40 L30 40 L0 10 Z" fill="url(#metalGrad)" />
        <path d="M10 0 L240 0" stroke="#00ffff" strokeWidth="4" filter="url(#neonCyan)" />
      </g>
    </svg>
  )
}
